<template>
  <!--begin::Lead Listing-->

  <div class="lead-template">
    <PageHeaderCount
      moduleType="lead"
      :dataLoading="dataLoading"
      :statusList="statusList"
      allkey="all_leads"
      countkey="lead_status_count"
    ></PageHeaderCount>
    <ListingTemplate :customClass="'lead-listing'">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-col cols="4" class="pt-0">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  {{ totalSelected }} Selected
                </h1>
              </v-col>
              <v-col cols="8" class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('lead:update')">
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="dataLoading"
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(item, index) in bulkActions">
                        <v-list-item
                          link
                          v-on:click="updateLeadStatus(item.action)"
                          :key="index"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              item.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ item.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" class="pt-0 col-lg-6">
                <h1 class="form-title d-flex margin-auto">
                  <v-select
                    :disabled="dataLoading"
                    :items="statusList"
                    v-model="status"
                    hide-details
                    item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter"
                    item-text="text"
                    item-value="value"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          :color="item.color"
                          :text-color="item.textcolor"
                        >
                          <template v-if="item.value == 'all'">{{
                            item.all_leads
                          }}</template>
                          <template v-else>{{
                            item.lead_status_count
                          }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-col>
              <v-col
                cols="8"
                class="pt-0 justify-flex-end d-flex margin-auto col-lg-6 all-project-btn-right"
              >
                <template v-if="getPermission('lead:create')">
                  <v-btn
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button custom-btn-color white--text"
                    :to="getDefaultRoute('lead.create')"
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <v-btn
                  :disabled="dataLoading"
                  depressed
                  class="mx-2 custom-bold-button"
                  color="cyan white--text"
                  v-on:click="exportDialog = true"
                >
                  <v-icon dark left>mdi-database-export</v-icon> Export
                </v-btn>

                <v-menu
                  max-height="400"
                  max-width="250"
                  offset-y
                  left
                  :close-on-content-click="false"
                  content-class="white-background"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button btn-tab-hide"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    v-on:change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          color="cyan"
                          hide-details
                          class="pt-2 mt-0"
                          v-on:change="updateVisible()"
                        ></v-checkbox>
                        <v-icon
                          class="draggable-drag-icon"
                          small
                          right
                          color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button btn-tab-hide"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ entityObject.name || "All Entities" }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in entityList"
                      :key="index"
                      link
                      v-on:click="updateEntity(item)"
                    >
                      <v-list-item-title class="font-weight-600">
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <PageTips v-if="false" module="lead"></PageTips>
              </v-col>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Lead"
          :basicSearchFields="[
            'barcode',
            'lead_name',
            'email',
            'phone_number',
            'source',
            'opportunity',
            'product_type',
            'amount',
            'status',
            'assigned_user',
          ]"
          :allowedSearchFields="searchableArray"
          :assignedUsers="userList"
          :criteriaValues="listingSearch"
        ></ListingSearchCriteria>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.id"
                      class="simple-table-th"
                      :class="{ 'checkbox-width-limit': cols.checkbox }"
                      :style="{ 'max-width': cols.width }"
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading || lodash.isEmpty(rowData)"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          v-on:click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : 'javascript:void(0)'
                          "
                        >
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'asc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-ascending</v-icon
                          >
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'desc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-descending</v-icon
                          >
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="!dataLoading">
                  <template v-if="!lodash.isEmpty(rowData)">
                    <tr v-for="(data, index) in rowData" :key="index" link>
                      <template v-for="cols in customThead">
                        <td
                          v-if="cols.visible"
                          :key="cols.id"
                          :class="{
                            'simple-table-td': !cols.checkbox,
                            'checkbox-width-limit': cols.checkbox,
                          }"
                          :style="{ 'max-width': cols.width }"
                          v-on:click="
                            Number(cols.checkbox) == 0
                              ? rowClicked(data)
                              : 'javascript:void(0)'
                          "
                        >
                          <template
                            v-if="cols.checkbox && Number(cols.checkbox) == 1"
                          >
                            <v-checkbox
                              dense
                              v-model="selectedRows"
                              v-bind:value="data.id"
                              color="cyan"
                              class="hide-margin"
                              hide-details
                            ></v-checkbox>
                          </template>
                          <template v-else-if="cols.field == 'barcode'">
                            <Barcode :barcode="data.barcode"></Barcode>
                          </template>

                          <template v-else-if="cols.field == 'lead_info'">
                            <div class="lead-listing">
                              <p class="m-0">
                                <b>Name: </b>
                                <template v-if="data && data.lead_name">
                                  <b
                                    class="fw-500"
                                    style="font-weight: 700 !important"
                                  >
                                    {{ data.lead_name }}</b
                                  >
                                </template>
                                <em v-else class="text-muted"> no name</em>
                              </p>

                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Email: </b>

                                <template v-if="data && data.email">
                                  {{ data.email }}
                                </template>
                                <em v-else class="text-muted"> no email</em>
                              </p>
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Phone: </b>
                                <template v-if="data && data.phone_number">
                                  {{ data.phone_number }}
                                </template>
                                <em v-else class="text-muted"> no phone</em>
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'source'">
                            <SelectSource
                              :source="sourceList"
                              :selected="data.source"
                              @change="currentStatus = $event"
                              v-if="false"
                            />
                            <div
                              class="lead-listing"
                              @click.stop
                              @keydown.enter.stop
                            >
                              <template v-if="data.source">
                                <v-autocomplete
                                  style="width: 180px !important"
                                  hide-details
                                  v-model.trim="data.source"
                                  :items="sourceList"
                                  @change="handleSourceChange(data)"
                                  dense
                                  flat
                                  filled
                                  placeholder="Source"
                                  item-color="cyan"
                                  color="cyan"
                                  solo
                                  item-value="value"
                                  item-text="text"
                                  :menu-props="{ maxWidth: '200px' }"
                                >
                                  <template v-slot:no-data>
                                    <v-list-item>
                                      <v-list-item-title
                                        v-html="'No Source(s) Found.'"
                                      ></v-list-item-title>
                                    </v-list-item>
                                  </template>
                                </v-autocomplete>
                              </template>
                              <em v-else class="text-muted"> no source</em>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'latest_note'">
                            <div class="d-flex align-center">
                              <div class="flex-grow-1" style="min-width: 0">
                                <template v-if="data.latest_note">
                                  <v-tooltip
                                    bottom
                                    max-width="400"
                                    :disabled="!data.latest_note.notes_remark"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <div
                                        v-bind="attrs"
                                        v-on="on"
                                        style="
                                          max-width: 150px;
                                          overflow: hidden;
                                          white-space: nowrap;
                                          text-overflow: ellipsis;
                                          cursor: default;
                                        "
                                      >
                                        {{ data.latest_note.notes_remark }}
                                      </div>
                                    </template>
                                    <span
                                      style="
                                        white-space: pre-wrap;
                                        word-break: break-word;
                                      "
                                    >
                                      {{ data.latest_note.notes_remark }}
                                    </span>
                                  </v-tooltip>
                                  <small class="text-muted">{{
                                    formatDate(data.latest_note.added_at)
                                  }}</small>
                                </template>
                                <em v-else class="text-muted">no notes</em>
                              </div>

                              <v-icon
                                color="green"
                                class="ml-2"
                                @click.stop="openNotes(data)"
                                >mdi-chat</v-icon
                              >
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'opportunity'">
                            <div
                              class="lead-listing"
                              @click.stop
                              @keydown.enter.stop
                            >
                              <v-autocomplete
                                style="width: 180px !important"
                                hide-details
                                v-model.trim="data.opportunity"
                                :items="opportunityList"
                                @change="handleOpportunityChange(data)"
                                dense
                                flat
                                filled
                                placeholder="Select Opportunity"
                                item-color="cyan"
                                color="cyan"
                                solo
                                item-value="value"
                                item-text="text"
                              >
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-title
                                      v-html="'No Opportunity(s) Found.'"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'product_type'">
                            <template v-if="data.product_type">
                              <v-chip
                                small
                                color="chip-custom-blue"
                                outlined
                                label
                                style="padding: 10px"
                              >
                                <span
                                  class="font-size-16 font-weight-500 text-capitalize"
                                >
                                  {{ data.product_type }}
                                </span>
                              </v-chip>
                            </template>
                            <em v-else class="text-muted"> no product type </em>
                          </template>
                          <template v-else-if="cols.field == 'amount'">
                            <template v-if="data.amount && data.amount > 0">
                              <v-chip
                                small
                                class="py-0"
                                color="green"
                                label
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  max-width: 150px;
                                "
                              >
                                <span class="text-white">
                                  <b>${{ " " + data.amount }}</b>
                                </span>
                              </v-chip>
                            </template>
                            <em v-else class="text-muted"> no amount </em>
                          </template>

                          <template v-else-if="cols.field == 'status'">
                            <template v-if="data.status">
                              <v-chip
                                small
                                :color="`${statusColor(
                                  data.status
                                )} white--text`"
                                label
                                class="mt-2"
                                style="padding: 10px"
                              >
                                <span class="font-size-16 font-weight-700">{{
                                  getFormattedText(data.status)
                                }}</span>
                              </v-chip>
                            </template>
                            <em v-else class="text-muted"> no status </em>
                          </template>

                          <template v-else-if="cols.field == 'assign_to'">
                            <template v-if="data.assigned_user">
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b
                                  class="fw-500 ms-1"
                                  style="font-weight: 700 !important"
                                >
                                  {{ data.assigned_user.display_name }}
                                </b>
                              </p>
                            </template>
                            <em v-else class="text-muted">
                              no assigned user
                            </em>
                          </template>
                          <template v-else-if="cols.field == 'entity'">
                            <template
                              v-if="
                                data.entity_detail && data.entity_detail.name
                              "
                            >
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b
                                  class="fw-500 ms-1"
                                  style="font-weight: 700 !important"
                                >
                                  {{ data.entity_detail.name }}
                                </b>
                              </p>
                            </template>
                            <em v-else class="text-muted">no entity</em>
                          </template>
                          <template
                            v-else-if="cols.field == 'expected_close_date'"
                          >
                            <template v-if="data.expected_close_date">
                              <span>
                                {{ formatDate(data.expected_close_date) }}
                              </span>
                            </template>
                            <em v-else class="text-muted">
                              no expected close date
                            </em>
                          </template>
                          <template
                            v-else-if="cols.field == 'actual_closed_date'"
                          >
                            <template v-if="data.actual_closed_date">
                              <span>
                                {{ formatDate(data.actual_closed_date) }}
                              </span>
                            </template>
                            <em v-else class="text-muted">
                              no actual closed date
                            </em>
                          </template>
                          <template v-else-if="cols.field == 'added_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.added_by)"
                              :data="data"
                            >
                              <template v-slot:display_name>
                                {{ data.added_by?.display_name }}
                              </template>
                              <template v-slot:date_time>
                                <!-- {{ data.created_at }} -->
                                <template
                                  v-if="getDateCountAll(data.added_at)"
                                  >{{ data.created_at }}</template
                                >
                                <template v-else>{{
                                  formatDateTime(data.added_at)
                                }}</template>
                              </template>
                              <template v-slot:format_date_time>
                                {{ formatDate(data.added_at) }}
                                {{ formatTime(data.added_at) }}
                              </template>
                            </TableActivity>
                          </template>
                          <template v-else-if="cols.field == 'updated_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.updated_by)"
                              :data="data"
                            >
                              <template v-slot:display_name>
                                {{ data.updated_by.display_name }}
                              </template>
                              <template v-slot:date_time>
                                {{ data.modified_at }}
                              </template>
                              <template v-slot:format_date_time>
                                {{ formatDateTime(data.updated_at) }}
                              </template>
                            </TableActivity>
                          </template>
                          <template v-else>
                            <div v-html="printRowData(cols, data)"></div>
                          </template>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <tr v-else-if="!dataLoading">
                    <td :colspan="15" class="py-4">
                      <p
                        class="m-0 row-not-found text-center font-weight-500 font-size-16"
                      >
                        <img
                          :src="$assetURL('media/error/empty.png')"
                          class="row-not-found-image"
                        />
                        Uhh... There are no lead at the moment.
                      </p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
        <Dialog :commonDialog="searchDialog">
          <template v-slot:title>Filter Lead</template>
          <template v-slot:body>
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <v-col md="6">
                    <v-menu
                      v-model="datePicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          filled
                          flat
                          label="Lead Created Date Range"
                          hide-details
                          solo
                          clearable
                          v-on:click:clear="dates = []"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :value="formattedDate"
                          color="cyan"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="cyan"
                        range
                        v-model="dates"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="6">
                    <v-menu
                      v-model="expectedCloseDatePicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          filled
                          flat
                          label="Expected Close Date"
                          hide-details
                          solo
                          clearable
                          v-on:click:clear="expectedCloseDates = []"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :value="expectedCloseDateFormatted"
                          color="cyan"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="cyan"
                        range
                        v-model="expectedCloseDates"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="6">
                    <v-menu
                      v-model="actualClosedDatePicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          filled
                          flat
                          label="Closed Date"
                          hide-details
                          solo
                          clearable
                          v-on:click:clear="actualClosedDates = []"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :value="actualClosedDateFormatted"
                          color="cyan"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="cyan"
                        range
                        v-model="actualClosedDates"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <template v-for="(field, index) in searchableArray">
                    <v-col
                      md="6"
                      :key="index"
                      v-if="
                        field != 'dates' &&
                        field != 'expected_close_date' &&
                        field != 'actual_closed_date'
                      "
                    >
                      <v-autocomplete
                        v-if="
                          ['source', 'product_type', 'assign_to'].includes(
                            field
                          )
                        "
                        v-model="listingSearch[field]"
                        :items="
                          field === 'source'
                            ? sourceList
                            : field === 'product_type'
                            ? productTypeList
                            : userList
                        "
                        :item-value="
                          field === 'source'
                            ? 'value'
                            : field === 'product_type'
                            ? 'text'
                            : 'id'
                        "
                        :item-text="
                          field === 'assign_to' ? 'display_name' : 'text'
                        "
                        dense
                        filled
                        hide-details
                        :label="getFilterLabel(field, 'Lead')"
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-autocomplete>
                      <v-text-field
                        v-else
                        v-model.trim="listingSearch[field]"
                        dense
                        filled
                        hide-details
                        :label="getFilterLabel(field, 'Lead')"
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
            <v-btn
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>
        <ExportDialog
          :dialog="exportDialog"
          title="Export Leads"
          module="lead"
          :queryParams="queryParams"
          :listingSearch="listingSearch"
          v-on:close="exportDialog = false"
        ></ExportDialog>
        <FullDialog
          v-if="notesDialog"
          :dialog="notesDialog"
          content-class="testdata"
        >
          <template v-slot:title>
            {{ selectedLead.lead_name }} ( {{ selectedLead.barcode }} ) Notes
            <v-spacer></v-spacer>
            <v-btn
              class="text-white"
              color="red darken-4"
              depressed
              tile
              v-on:click="closeNotes"
            >
              Close
            </v-btn>
          </template>
          <template v-slot:body>
            <ChatNote
              v-if="notesDialog"
              :relatedId="Number(selectedLead.id)"
              :relatedType="'lead'"
              :documentTypes="50"
              create-url="lead-notes"
              get-url="lead-notes"
            ></ChatNote>
          </template>
        </FullDialog>
      </template>
    </ListingTemplate>
  </div>
  <!--end::Lead Listing-->
</template>

<script>
import moment from "moment";
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import AppConfiguration from "@/core/config/app.config";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { PATCH, QUERY } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import SelectSource from "@/view/pages/partials/SelectSource.vue";
import ExportDialog from "@/view/pages/partials/Export-Dialog.vue";
import FullDialog from "@/view/components/FullDialog";
import ChatNote from "@/view/pages/partials/ChatNote";

export default {
  mixins: [CommonMixin, ListingMixin],
  name: "lead-list",
  data() {
    return {
      exportLoading: false,
      dates: [],
      expectedCloseDates: [],
      actualClosedDates: [],
      expectedCloseDatePicker: false,
      actualClosedDatePicker: false,
      pageModule: "lead-listing",
      routeAPI: "leads",
      routeName: "lead",
      routeDetailName: "lead.detail",
      status: "all",
      menu: false,
      exportDialog: false,
      statusList: [],
      productTypeList: [],
      userList: [],
      notesDialog: false,
      selectedLead: {},

      opportunityList: [
        {
          text: "High Chance",
          value: "High Chance",
        },
        {
          text: "50 50",
          value: "50 50",
        },
        {
          text: "Low Chance",
          value: "Low Chance",
        },
        {
          text: "None",
          value: "None",
        },
      ],

      sourceList: [
        {
          text: "Web Enquiry",
          value: "Web Enquiry",
        },
        {
          text: "Web Chat",
          value: "Web Chat",
        },
        {
          text: "Email Marketer",
          value: "Email Marketer",
        },
        {
          text: "Tele Call",
          value: "Tele Call",
        },
        {
          text: "Google Adwords",
          value: "Google Adwords",
        },
        {
          text: "Fsm/Ams",
          value: "Fsm/Ams",
        },
        {
          text: "Facebook",
          value: "Facebook",
        },
        {
          text: "Referral",
          value: "Referral",
        },
        {
          text: "Intern",
          value: "Intern",
        },
        {
          text: "Canvassing Team",
          value: "Canvassing Team",
        },

        {
          text: "None",
          value: "None",
        },
      ],
      customThead: [],
      moreActions: [
        /*{
          title: "Export Lead(s)",
          action: "export_items",
          divider: false,
          icon: "mdi-database-export"
        },
        {
          title: "Export Current View",
          action: "export_current_view",
          divider: true,
          icon: "mdi-database-export"
        },*/
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      bulkActions: [
        {
          title: "Mark as Not Contacted",
          action: "Not Contacted",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Follow Up",
          action: "Follow Up",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Meeting",
          action: "Meeting",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Converted to Customer",
          action: "Converted to Customer",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Rejected",
          action: "Rejected",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Accepted",
          action: "Accepted",
          icon: "mdi-check-all",
        },
      ],
    };
  },
  watch: {
    dates: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param.length > 1) {
          this.listingSearch["dates"] = param.map((date) =>
            moment(date).format("YYYY-MM-DD")
          );
        } else {
          this.listingSearch["dates"] = undefined;
        }
      },
    },
    expectedCloseDates: {
      deep: true,
      handler(param) {
        this.listingSearch.expected_close_date =
          param && param.length > 1
            ? param.map((date) => moment(date).format("YYYY-MM-DD"))
            : undefined;
      },
    },
    actualClosedDates: {
      deep: true,
      handler(param) {
        this.listingSearch.actual_closed_date =
          param && param.length > 1
            ? param.map((date) => moment(date).format("YYYY-MM-DD"))
            : undefined;
      },
    },
  },
  computed: {
    expectedCloseDateFormatted() {
      const config = AppConfiguration.get();
      const format =
        config && config.dateFormat ? config.dateFormat : "YYYY-MM-DD";
      return this.expectedCloseDates
        .map((date) => moment(date).format(format))
        .join(" ~ ");
    },
    actualClosedDateFormatted() {
      const config = AppConfiguration.get();
      const format =
        config && config.dateFormat ? config.dateFormat : "YYYY-MM-DD";
      return this.actualClosedDates
        .map((date) => moment(date).format(format))
        .join(" ~ ");
    },
  },
  components: {
    PageHeaderCount,
    draggable,
    PageTips,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
    SelectSource,
    ExportDialog,
    FullDialog,
    ChatNote,
  },
  methods: {
    getLeadOptions() {
      this.$store
        .dispatch(QUERY, { url: "lead/options" })
        .then(({ data }) => {
          this.productTypeList = data.product_types || [];
          this.userList = data.users || [];
        })
        .catch((error) => {
          this.logError(error);
        });
    },

    selectStatus(item) {
      this.selectedStatus = item;
      this.menu = false;
    },

    openNotes(row) {
      this.selectedLead = row;
      this.notesDialog = true;
    },

    closeNotes() {
      this.notesDialog = false;
      this.selectedLead = {};
      this.getRows();
    },

    statusColor(status) {
      const statusMapping = {
        "Not Contacted": "grey",
        "Follow Up": "yellow",
        Meeting: "blue",
        "Converted to Customer": "orange",
        Accepted: "green",
        Rejected: "red",
      };

      return statusMapping[status] || "grey";
    },

    getFormattedText(status) {
      if (!status) return "";
      return status
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },

    updateLeadStatus(status) {
      const _this = this;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "leads/status",
          data: { lead: _this.selectedRows, status },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },

    handleSourceChange(row) {
      this.updateLeadSource(row);
    },

    updateLeadSource(row) {
      const _this = this;
      const lead_id = row.id;
      const source = row.source;
      const url = `leads/source/${lead_id}`;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: url,
          data: { source: source },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },

    handleOpportunityChange(row) {
      this.updateLeadOpportunity(row);
    },

    updateLeadOpportunity(row) {
      const _this = this;
      const lead_id = row.id;
      const opportunity = row.opportunity;
      console.log(opportunity);
      const url = `leads/opportunity/${lead_id}`;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: url,
          data: { opportunity: opportunity },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },

    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          break;
        case "export_items":
          _this.LeadExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("lead");
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Lead",
      },
    ]);
    this.getLeadOptions();
    this.getRows();
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    if (Array.isArray(_this.$route.query.expected_close_date)) {
      _this.expectedCloseDates = _this.$route.query.expected_close_date;
    }
    if (Array.isArray(_this.$route.query.actual_closed_date)) {
      _this.actualClosedDates = _this.$route.query.actual_closed_date;
    }

    _this.status = _this.$route.query.status || _this.status;

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
